module.exports = __webpack_public_path__ + "static/media/facebook.47fc995d.svg";